// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './sidebar';
import Login from './Login';
import CategoryList from './category/CategoryList';
import SubcategoryList from './subcategory/SubCategoryList';
import ProductList from './product/ProductList';
import PackagesList from './packages/PackagesList';
import NotesList from './notes/NotesList';
import VideoList from './video/Videolist';
import AlbumList from './album/AlbumList';

function Layout() {
  const location = useLocation(); // Correct usage of useLocation within Router context

    return (
    <>
      {location.pathname !== '/login' && <Sidebar />}

      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/category-list" element={<CategoryList />} />
        <Route path="/subcategory-list" element={<SubcategoryList />} />
        <Route path="/product-list" element={<ProductList />} />
        <Route path="/Packages-list" element={<PackagesList />} />
        <Route path="/Notes-list" element={<NotesList />} />
        <Route path="/Video-list" element={<VideoList />} />
        <Route path="/Album-list" element={<AlbumList />} />
      </Routes>
    </>
  );
}

function AppWrapper() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default AppWrapper;
